import * as types from './action-types';
import * as itemListFormApi from '../api/item-list-form-api';
import { beginApiCall, apiCallError } from './api-status-actions';

export function loadSSOItemListFormDataSuccess(itemListFormData) {
    return { type: types.LOAD_ITEM_LIST_FORM_DATA_SUCCESS, itemListFormData };
}

export function loadSSOItemListFormDataError() {
    return { type: types.LOAD_ITEM_LIST_FORM_DATA_ERROR };
}


export function loadSSOItemListFormData(formDataUrl = '', formId = '') {
    return function (dispatch) {
        dispatch(beginApiCall());
        return itemListFormApi.getSSOItemListFormData(formDataUrl, formId)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSOItemListFormDataError());
                    return;
                }
                dispatch(loadSSOItemListFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSOItemListFormDataError());
                throw error;
            });
    };
}